<script lang="ts">
    export let value;
    export let label;
    export let name;
    export let allOptions;
    export let error = null;
</script>
<div class="field">
    <label class="label" for={name}>{label}</label>
    <div>
        <select class="select column is-12 is-6-desktop p-0 pl-1" id={name} on:change bind:value {...$$restProps} >
            <option value="">Veuillez selectionner une option</option>
            {#each allOptions as option}
                <option value={option}>
                    {option}
                </option>
            {/each}
        </select>
    </div>
    {#if error}
        <p class="help is-danger">{error}</p>
    {/if}
</div>
